import { PerformanceRankingPuck } from "./performance-ranking-puck";

export class PerformanceRankingSlot {

  sequenceNo!: number;
  performanceRanking!: PerformanceRankingPuck;

  constructor(
    sequenceNo: number,
    performanceRanking: PerformanceRankingPuck,
  ) { 
    this.sequenceNo = sequenceNo;
    this.performanceRanking = performanceRanking;
  }
}